var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.351 6.35A7.992 7.992 0 0120 12c0 4.42-3.572 8-7.995 8-3.732 0-6.844-2.55-7.735-6h2.081c.821 2.33 3.042 4 5.654 4 3.312 0 6.004-2.69 6.004-6s-2.692-6-6.004-6c-1.661 0-3.142.69-4.223 1.78l2.368 2.366a.499.499 0 01-.353.854H5a1 1 0 01-1-1V5.207a.5.5 0 01.853-.354L6.351 6.35z"
  })));
}
export default __webpack_public_path__ + "static/media/c98474b89b64ab00e4a332a7a6ee24d9-clear-all.svg";
export { SvgClearAll as ReactComponent };